import { render, staticRenderFns } from "./noraml-user-org-list.html?vue&type=template&id=33207e5c&scoped=true&external"
import script from "./noraml-user-org-list.js?vue&type=script&lang=js&external"
export * from "./noraml-user-org-list.js?vue&type=script&lang=js&external"
import style0 from "./noraml-user-org-list.scss?vue&type=style&index=0&id=33207e5c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33207e5c",
  null
  
)

export default component.exports